import React from 'react';
import Footer from '../../common/Footer';

const AdvantageFooter = () => {
  return <Footer />;
};

export default AdvantageFooter;
